<template>
    <div>
        <span
            :class="['filter-cta', {
                active: region.name === currentRegion
            }]"
            @click="$emit('toggle-region', region)"
        >{{region.name}}<IconDown :direction="region.name === currentRegion ? 'right' : 'down'"/>
        </span>
        <div class="countries-container">
            <a
                :key="market.id"
                v-if="region.name === currentRegion"
                v-for="market in filteredCountries"
                @click="$emit('handle-click', market)"
                :class="['filter-cta', {
                    active: market.id === countryId
                }]"
            >
                <span class="underline">{{market.name}}</span>
            </a>
        </div>
    </div>
</template>

<script>
import IconDown from '@/components/IconDown'
export default {
    components: {
        IconDown
    },
    props: {
        region: {
            type: Object,
            default() {return []}
        },
        filteredCountries: {
            type: Array,
            default() {return []}
        },
        currentRegion: {
            type: String
        },
        countryId: {
            type: String | Number
        }
    },
    data() {
        return {
            display: false
        }
    },
    methods: {
        toggleRegion() {
            this.display = !this.display
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.filter-cta
    font-size: 17px
    font-weight: 500
    color: #636772
    display: block
    line-height: 2.3529411765em
    cursor: pointer
    display: flex
    align-items: center
    justify-content: space-between
    padding-right: 24%
    &.active
        color: #ff2b2a
        svg
            /deep/ path
                stroke: #ff2b2a
.countries-container
    @include media-breakpoint-up($md)
        display: none
</style>
